import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    service_beginDate: null,
    service_lastDate: null,
    service_datasets: [],
    //v2
    service_isLoading: false,
    service_table: null,
    service_total: 0,
    service_type: [],
}

// getters
const getters = {
    service_date: state => {
        return { start: state.service_beginDate, end: state.service_lastDate }
    },
    service_data_date: state => {
        return "N/A"
    },
    service_datasets: state => {
        return state.service_datasets;
    },
    service_isLoading: state => {
        return state.service_isLoading;
    },
    service_table: state => {
        return state.service_table;
    },
}

// actions
const actions = {
    getServiceDatasets(context, payload) {
        state.service_country_filter = null;
        state.service_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.location_destination !== null) {
                _params.location_destination = main_filters.location_destination;
            }
        }



        // calulate _params from sub_filters
        // service_type, q, limit, page, sort
        _params.limit = 5;
        _params.page = 1;
        var sub_filter = payload.sub_filter;
        if (sub_filter !== null) {
            if (sub_filter.service_type !== null) {
                _params.service_type = sub_filter.service_type;
            }
            if (sub_filter.q !== "") {
                _params.q = sub_filter.q;
            }
            if (sub_filter.limit > 0) {
                _params.limit = sub_filter.limit;
            }
            if (sub_filter.page > 0) {
                _params.page = sub_filter.page;
            }
            if (sub_filter.sort != "") {
                _params.sort = sub_filter.sort;
            }
        }

        const request = {
            params: qs.parse(_params)
        };

        instance.get('market/service', request)
            .then(response => {
                const { service_type, count, rows } = response.data;
                state.service_datasets = rows;
                state.service_total = count;
                state.service_type = service_type;
                state.service_beginDate = moment().startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
                state.service_lastDate = moment().endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "service_table") {
                        context.commit("onServiceTable", payload);
                    }
                })
                state.service_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/market/service] syntax errors under instant.get");
            })

    }
}

// mutations
const mutations = {
    onServiceMutations(state, payload) {
        // --- start dataset doughnut for chart        
        // --- end dataset for doughnut chart
    },
    onServiceTable(state, payload) {
        // --- start dataset for v-data-table
        /**
         {
            "id": "5bdbffe33495f90010a611a2",
            "service_type": "ที่พัก",
            "service_name": "Amazing Thailand",
            "service_telephone": "095-445-5554",
            "service_address": "125-2/225 navamin bangkok 12210",
            "service_website": "http://travel.me",
            "location_zone": "เอเชีย",
            "location_source": "ไทย",
            "location_destination": "กรุงเทพมหานคร",
            "location_destination_region": "ภาคกลาง",
            "createdAt": "2018-11-02T07:42:27.323Z",
            "updatedAt": "2018-11-02T07:42:27.323Z"
        }
        */
        var rows = state.service_datasets;
        var _service_datatable = {
            headers: [
                { text: 'Type', value: "service_type", align: 'left' },
                { text: 'Name', value: "service_name", align: 'left' },
                { text: 'Telephone', value: "service_telephone", align: 'left' },
                { text: 'Address', value: "service_address", align: 'left' },
                { text: 'Destination', value: "location_destination", align: 'left' },
                { text: 'Website', value: "service_website", align: 'left' }
            ],
            items: [{
                value: false,
                service_type: '',
                service_name: '',
                service_telephone: '',
                service_address: '',
                location_destination: '',
                service_website: '',
            }],
            pagination: {
                sortBy: 'service_name',
                descending: false,
            },
            total: 0,
        };

        // build items
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {
                value: false,
                service_type: item.service_type,
                service_name: item.service_name,
                service_telephone: item.service_telephone,
                service_address: item.service_address,
                location_destination: item.location_destination,
                service_website: item.service_website,
            }
            items.push(_item);
        });
        _service_datatable.items = items;
        _service_datatable.total = state.service_total;
        _service_datatable.service_type = state.service_type.sort(function(a, b) { return a.localeCompare(b) });
        state.service_table = _service_datatable;
        // --- start dataset for v-data-table
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}